<template>
  <div class="company-detail flex-column flex-column-1">
    <div class="banner">
      <div class="head">
        <i class="fa fa-angle-left" @click="back"></i>
        <!--<div class="share" @click="share">分享</div>-->
      </div>

      <mt-swipe :auto="4000" style="height:200px;">
        <template v-for="(item, index) in '12345'">
          <mt-swipe-item v-if="company['companyImgUrl' + index]" :key="index">
            <img class="img-fluid" :src="getImgUrl(company['companyImgUrl' + index])" alt
          /></mt-swipe-item>
        </template>
      </mt-swipe>
    </div>
    <div class="company-info">
      <div class="d-flex justify-content-between align-items-center">
        <div class="company-title">
          <div>{{ company.companyName }}</div>
          <div class="lable">
            <Label :companyLabels="company.companyLabel" />
          </div>
        </div>
        <div class="d-flex flex-column align-items-center collect" v-if="!isFavorites" @click="clloect(1)">
          <i class="fa fa-star-o"></i>
          <span>收藏</span>
        </div>
        <div class="d-flex flex-column align-items-center collect" v-else @click="clloect(0)">
          <i class="fa fa-star-o"></i>
          <span>移除</span>
        </div>
      </div>
      <div
        v-if="this.company.businessRouteLine"
        class="d-flex justify-content-between align-items-center addre-cotainer"
      >
        <div class="d-flex align-items-stretch">
          <div class="text-justify addre">
            <div class="inner-addre">经营线路:</div>
          </div>
          <div class="address-right address-right1">
            <div>{{ this.company.businessRouteLine }}</div>
          </div>
        </div>
        <div class="d-flex flex-column align-items-center collect"></div>
      </div>
      <div class="d-flex justify-content-between align-items-center addre-cotainer">
        <div class="d-flex align-items-stretch">
          <div class="text-justify addre">
            <div class="inner-addre">地址 :</div>
          </div>
          <div class="address-right">
            <div>{{ company.companyAddr }}</div>
          </div>
        </div>
        <div class="d-flex flex-column align-items-center collect">
          <!-- <i class="fa fa-send"></i> -->
          <img class="send" @click="toMap(company)" :src="require('@/assets/imgs/icons/logisticsNav.png')" alt />
        </div>
      </div>

      <div class="information d-flex align-items-center justify-content-between">
        <div>
          <h4 class="name-tel-phone">
            {{ company.serverName }}
            <small>{{ company.servicePhoneNo }}</small>
          </h4>
          <span>拨打电话可咨询了解更详细信息</span>
        </div>
        <div class="align-items-center justify-content-between d-flex">
          <!--<span class="icon">
	            <i class="fa fa-weixin"></i>
	          </span>-->

          <a class="icon" :href="`tel:${company.servicePhoneNo}`">
            <i class="fa fa-volume-control-phone"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="dot-list">
      <h5 class="title netdot-title">卸货网点</h5>
      <ul class="">
        <!--  -->
        <li v-for="(item, index) in allData" :key="index">
          <div
            class="btn btn-block btn-success"
            @click="changeNode(item, index)"
            :class="{ activeBtn: index == activeBtn }"
          >
            {{ item.companyName }}
          </div>
        </li>
      </ul>
    </div>
    <div class="detail-list">
      <h5 class="title">详细列表</h5>
      <div class="item">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-start">
            <div class="netdot">
              <span v-if="lineList">{{ lineList.companyName }}</span
              >网点
            </div>
            <span class="text-blue"
              ><span v-if="lineList">{{ lineList.companyAddr }}</span></span
            >
          </div>
          <span class="guide" @click="toMap(lineList.companyAddr)"
            ><img class="send" :src="require('@/assets/imgs/icons/logisticsNav.png')" alt
          /></span>
        </div>
        <!-- <div class="d-flex justify-content-start">
	          <span class="babel-title">重货运价:</span> 
	          <span ><span class="text-danger">380/吨</span>(1吨小于3方):</span> 
	        </div>
	
	        <div class="d-flex justify-content-start">
	          <span class="babel-title">轻货运价:</span> 
	          <span ><span class="text-danger">380/吨</span>(1吨小于6方)</span> 
	        </div>
	
	        <div class="d-flex justify-content-start">
	          <div class="babel-title">轻货运价:</div> 
	          <span ><span class="text-danger">380/吨</span>(1吨小于6方)</span> 
	        </div> -->
        <div v-if="lineList" class="d-flex justify-content-start">
          <span v-if="lineList.serviceName" class="babel-title">联系人:</span>
          <span v-if="lineList.serviceName">{{ lineList.serviceName }}</span>
        </div>

        <div v-if="lineList" class="d-flex justify-content-start">
          <span v-if="lineList.servicePhoneNo" class="babel-title">联系电话:</span>
          <span v-if="lineList.servicePhoneNo">{{ lineList.servicePhoneNo }}</span>
        </div>
        <div class="d-flex justify-content-start" v-if="subOrgLines" v-for="(item, index) in subOrgLines">
          <span class="babel-title"><font v-if="index == 0">路线时效:</font></span>
          <font
            ><font>{{ item.timeLimitStr }}</font></font
          >
        </div>
        <div v-if="lineList" class="d-flex justify-content-start">
          <span v-if="lineList.radiationNodeName" class="babel-title">辐射网点:</span>
          <span v-if="lineList.radiationNodeName">{{ lineList.radiationNodeName }}</span>
        </div>
      </div>
    </div>
    <mapApp v-if="hasMap"></mapApp>
  </div>
</template>
<script>
import Label from "@/components/function/label/label.vue";
import { companys } from "@/assets/mock.data";
import { Toast, MessageBox } from "mint-ui";
import { GET_COMPANY_ROUTE_LINE_INFO, SAVE_OR_UPDATA_FAVORITE_ORGANIZATION } from "@/assets/configs/api/otmsApi.js";
import { ROOT_REQUEST } from "@/assets/configs";
export default {
  components: { Label },
  data() {
    return {
      company: [],
      organizationId: null,
      allData: [],
      lineList: [],
      activeBtn: 0,
      subOrgLines: [],
      isFavorites: false
    };
  },
  computed: {
    hasMap() {
      //    return companys[this.$route.params.index]
      return this.$store.state.hasMap;
    }
  },
  methods: {
    getImgUrl(imgUrl) {
      var t = new Date().getTime();
      return imgUrl + `?t=${t}`;
    },
    back() {
      this.$router.push({ name: "company-list", query: {} });
    },
    clloect(num) {
      this.$post(
        SAVE_OR_UPDATA_FAVORITE_ORGANIZATION,
        {
          organizationId: this.organizationId,
          operation: num
        },
        data => {
          this.isFavorites = !this.isFavorites;
          if (num == 1) {
            Toast("收藏成功");
          } else if (num == 0) {
            Toast("移除收藏成功");
          }
        },
        error => {
          Toast(error);
        }
      );
    },
    changeNode(item, index) {
      this.subOrgLines = item.subOrgLines;
      this.lineList = item;
      this.activeBtn = index;
    },
    share() {
      let isWx = this.isWeiXin();
      if (isWx) {
        Toast("点击右上角分享");
      }
    },
    getJsApiParam() {
      var isWx = this.isWeiXin();
      if (isWx) {
        //微信打开
        var vm = this;
        window.sessionStorage.setItem("noLogin", true);
        this.$get(
          "https://www.b100y.com/truck-api/v002/commentLottoController/getJsApiParam",
          {
            type: 3,
            url: location.href
          },
          data => {
            window.sessionStorage.removeItem("noLogin");
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: data.appId, // 必填，公众号的唯一标识
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名，见附录1
              jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "getLocation"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            wx.error(function(err) {
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            });
            wx.ready(function(res) {});
          },
          error => {}
        );
      }
    },
    /*导航规划*/
    toMap(addressLink) {
      var vm = this;

      var isWx = this.isWeiXin();

      /*获取当前位置*/
      var map, geocoder, marker;

      map = new AMap.Map("container", {
        resizeEnable: true
      });

      var geocoder;
      //加载地理编码插件
      geocoder = new AMap.Geocoder({
        city: "全国"
      });

      //传的一个对象
      if (typeof addressLink == "object") {
        openMap(addressLink.companyAddr, addressLink.lat, addressLink.lon);
      } else {
        //传的地址字符串
        geocoder.getLocation(addressLink, function(status, result) {
          if (status == "no_data") {
            Toast("该地址无法定位");
          }
          if (status === "complete" && result.geocodes.length) {
            var lnglat = result.geocodes[0].location;
            openMap(addressLink, parseFloat(lnglat.lat), parseFloat(lnglat.lng));
          }
        });
      }

      function openMap(address, lat, lng) {
        if (isWx) {
          wx.openLocation({
            latitude: lat,
            longitude: lng,
            name: address,
            address: address,
            scale: 18,
            infoUrl: ROOT_REQUEST.web_base + "h5/specialline/#/home"
          });
        } else {
          vm.$store.state.parkLng = lat;
          vm.$store.state.parkLat = lng; /*选中园区的纬度*/
          vm.$store.state.hasMap = true;
        }
      }
    },
    getData() {
      this.$post(
        GET_COMPANY_ROUTE_LINE_INFO,
        { organizationId: this.organizationId },
        data => {
          this.isFavorites = data.isFavorites;
          this.company = data.companyInfo;
          this.lineList = data.lineList[0];
          this.subOrgLines = data.lineList[0].subOrgLines;
          this.allData = data.lineList;
          this.getJsApiParam();
          var route = "";
          if (data.companyInfo.startCityName.split(",")[0] && data.companyInfo.destCity.split(",")[0]) {
            route =
              "【" +
              data.companyInfo.startCityName.split(",")[0] +
              "-" +
              data.companyInfo.destCity.split(",")[0] +
              "】";
          }

          if (
            data.companyInfo.startCityName.split(",")[0] &&
            data.companyInfo.destCity.split(",")[0] &&
            data.companyInfo.destCity.split(",")[1]
          ) {
            route =
              "【" +
              data.companyInfo.startCityName.split(",")[0] +
              "-" +
              data.companyInfo.destCity.split(",")[0] +
              " " +
              data.companyInfo.destCity.split(",")[1] +
              "】";
          }

          route += this.company.companyName + "竭诚为您服务。发货请进入......  ";

          this.commonShare(location.href, this.company.companyName + "专线分享", route, location.href);
        },
        error => {}
      );
    }
  },
  mounted() {
    wx.miniProgram.postMessage({ data: { shareURL: location.href } });
    this.organizationId = this.$route.query.organizationId;
    this.getData();
  }
};
</script>
<style lang="scss" scoped>
@import "./detail";
</style>
